export default "__VITE_ASSET__DMN5z0Jp__"